import { Directive, ElementRef, input, Renderer2 } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[appAuthGroups]',
})
export class AuthGroupsDirective {

  appAuthGroups = input<string[]>();
  constructor(private el: ElementRef, private renderer: Renderer2, private auth: AuthService) { }

  ngOnInit() {
    // Replace this with your real group check logic
    const hasAccess = this.checkAccess();
    if (!hasAccess) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }

  // Dummy implementation, replace with your real logic
  private checkAccess(): boolean {
    const groups = this.appAuthGroups();
    if (!groups || groups.length === 0)
      return true;


    return this.auth.hasGroup(groups);
  }
}
